import { BLOG_IMAGES } from '../blogImages';

const post = {
    slug: 'kak-nachat-pervuyu-proverku-v-finradar',
    title: 'Как начать первую проверку в ФинРадаре',
    description: 'Пошаговая инструкция для первой проверки в ФинРадаре: как зарегистрироваться, создать проект, загрузить банковские выписки, проверить качество файлов и перейти к анализу оборотов, контрагентов, рисков и операций.',
    listDescription: 'Пошагово: регистрация, создание проекта, загрузка выписок, контроль качества и первый анализ операций, контрагентов и отчетов.',
    datePublished: '2026-04-30',
    datePublishedLabel: '30 апреля 2026',
    readingTime: '12 минут',
    category: 'Инструкция',
    articleSection: 'Инструкция',
    tags: ['Инструкция', 'Первая проверка', 'Загрузка выписок', 'Анализ выписок'],
    keywords: 'как начать работу в ФинРадаре, первая проверка выписки, анализ банковской выписки онлайн, загрузить банковскую выписку, сервис анализа банковских выписок, автоматический анализ выписки',
    heroImage: BLOG_IMAGES.projectsDashboard,
    content: [
        {
            type: 'lead',
            text: 'ФинРадар - это онлайн сервис для анализа банковских выписок, операций, контрагентов и рисков. Чтобы начать первую проверку, не нужно проходить сложное внедрение, настраивать интеграции или ждать отдельного обучения.',
        },
        {
            type: 'paragraph',
            text: 'Достаточно зарегистрироваться, создать проект, загрузить одну или несколько выписок и дождаться обработки. После этого можно перейти к первичному анализу: проверить качество загруженных данных, посмотреть обороты, контрагентов, реестр платежей, риски и аномалии.',
        },
        {
            type: 'paragraph',
            text: 'В этой инструкции разберем первый запуск по шагам.',
        },
        { type: 'divider' },
        { type: 'h2', text: 'Что понадобится перед стартом' },
        {
            type: 'paragraph',
            text: 'Для первой проверки лучше заранее подготовить данные, которые понадобятся для создания проекта и загрузки выписок.',
        },
        {
            type: 'list',
            items: [
                'ИНН компании, ИП или физического лица, по которому проводится анализ;',
                'банковские выписки в Excel, TXT / 1C Client-Bank, PDF или другом доступном формате;',
                'период анализа, который нужно проверить;',
                'несколько файлов, если выписки получены из разных банков, по разным счетам или за разные периоды.',
            ],
        },
        {
            type: 'paragraph',
            text: 'Лучше всего для быстрой обработки подходят XLS / XLSX и TXT / 1C Client-Bank. Также ФинРадар работает с текстовыми PDF и другими форматами банковских выписок. Некоторые файлы обрабатываются за несколько минут, а сложные или нестандартные форматы могут потребовать больше времени.',
        },
        {
            type: 'paragraph',
            text: 'Сканированные выписки также можно обрабатывать, но это более трудоемкий сценарий: распознавание сканов сложнее, дольше и дороже, чем работа с текстовыми или табличными файлами.',
        },
        { type: 'h2', text: 'Шаг 1. Зарегистрируйтесь в ФинРадаре' },
        {
            type: 'paragraph',
            text: 'Первый шаг - регистрация. В форме нужно указать email, имя и телефон, а также принять условия оферты и политики обработки персональных данных.',
        },
        {
            type: 'paragraph',
            text: 'После регистрации можно войти в сервис и начать первую проверку.',
        },
        { type: 'signup' },
        { type: 'h2', text: 'Шаг 2. Откройте рабочий экран и создайте новый проект' },
        {
            type: 'paragraph',
            text: 'После входа пользователь попадает на экран актуальных проектов. Здесь можно продолжить работу с уже созданными проверками или начать новый проект.',
        },
        {
            type: 'paragraph',
            text: 'Для первой проверки нажмите «Новый проект». Проект - это рабочее пространство, в котором собираются выписки, счета, операции, контрагенты и аналитика по одной компании, ИП, физическому лицу или группе связанных лиц.',
        },
        { type: 'image', image: BLOG_IMAGES.projectsDashboard },
        { type: 'h2', text: 'Шаг 3. Укажите название проекта и ИНН объекта анализа' },
        {
            type: 'paragraph',
            text: 'При создании проекта нужно указать название проекта и ИНН объекта анализа.',
        },
        {
            type: 'paragraph',
            text: 'ИНН важен для корректной идентификации владельца счета и дальнейшей аналитики. Если создать проект без ИНН, система может неверно определить владельца счета или некорректно отразить реквизиты, особенно если банк указывает данные в нестандартном формате.',
        },
        {
            type: 'list',
            items: [
                'стандартный анализ - для одной компании, ИП или физического лица;',
                'анализ группы - если нужно собрать выписки по нескольким связанным лицам или компаниям в одном проекте.',
            ],
        },
        {
            type: 'paragraph',
            text: 'Для первой проверки обычно достаточно стандартного анализа.',
        },
        { type: 'image', image: BLOG_IMAGES.createProject },
        { type: 'h2', text: 'Шаг 4. Загрузите банковские выписки' },
        {
            type: 'paragraph',
            text: 'После создания проекта можно добавить выписки. ФинРадар позволяет загрузить один или несколько файлов. Это удобно, если нужно проанализировать несколько банковских счетов, выписки за разные периоды, файлы из разных банков или отдельные выписки в Excel, TXT, PDF или другом формате.',
        },
        {
            type: 'paragraph',
            text: 'Выписки можно добавлять постепенно. Новые файлы будут дополнять общий массив проекта.',
        },
        {
            type: 'paragraph',
            text: 'Перед добавлением файлов с выписками, надо выбрать владельца счета. Если в выписке есть ИНН владельца счета, ФинРадар может проверить и исправить определить владельца автоматически.',
        },
        { type: 'image', image: BLOG_IMAGES.firstCheckUpload },
        { type: 'h2', text: 'Шаг 5. Дождитесь обработки файлов' },
        {
            type: 'paragraph',
            text: 'После загрузки файлы проходят обработку. Статус каждого файла отображается отдельно: можно видеть, какие выписки уже сохранены, какие находятся в очереди, какие отправляются на сервер и какие требуют внимания.',
        },
        {
            type: 'paragraph',
            text: 'Обработка зависит от формата файла, размера выписки и сложности структуры. Простые Excel или TXT-файлы обычно обрабатываются быстрее. Более сложные PDF, нестандартные форматы или сканы могут занимать больше времени.',
        },
        {
            type: 'paragraph',
            text: 'После завершения обработки можно перейти к работе с проектом.',
        },
        { type: 'h2', text: 'Шаг 6. Проверьте качество загруженных выписок' },
        {
            type: 'paragraph',
            text: 'Перед тем как анализировать обороты и риски, важно убедиться, что массив данных собран корректно. В ФинРадаре вы можете отслеживать:',
        },
        {
            type: 'list',
            items: [
                'сколько выписок загружено;',
                'сколько счетов обнаружено;',
                'есть ли проблемные выписки;',
                'какие файлы еще в обработке;',
                'есть ли счета с разрывами;',
                'есть ли счета с наложениями периодов;',
                'были ли данные изменены вручную.',
            ],
        },
        {
            type: 'paragraph',
            text: 'Это особенно важно, если в проект загружено несколько выписок по одному счету. Например, один файл может закрывать период с января по декабрь, а второй - частично пересекаться с этим же периодом. В таком случае может возникнуть дублирование операций.',
        },
        {
            type: 'paragraph',
            text: 'ФинРадар помогает увидеть такие ситуации до того, как пользователь начнет делать выводы по оборотам и контрагентам.',
        },
        { type: 'image', image: BLOG_IMAGES.firstCheckQuality },
        { type: 'h2', text: 'Шаг 7. Разберите проблемные выписки, если они есть' },
        {
            type: 'paragraph',
            text: 'Если ФинРадар показывает наложение периодов, дублирование операций или файл, требующий внимания, это не значит, что проект нужно создавать заново. В ФинРадаре можно удалять лишние выписки целиком, удалять отдельные периоды внутри любой выписки, изменять и уточнять промежуточные итоги и подытоги. ФинРадар позволяет:',
        },
        {
            type: 'list',
            items: [
                'открыть конкретную выписку;',
                'посмотреть ее период;',
                'сверить контрольные итоги и внести отсутствующие данные;',
                'просмотреть операции, которые добавляются к общему массиву проекта;',
                'удалить операции за пересекающийся период;',
                'уточнить данные, если файл обработан не так, как ожидалось.',
            ],
        },
        {
            type: 'paragraph',
            text: 'Это важно для корректной аналитики. Если не убрать дубли или наложения, обороты, списания, поступления и показатели по контрагентам могут быть завышены.',
        },
        {
            type: 'paragraph',
            text: 'Для арбитражных управляющих, кредитных аналитиков и брокеров это особенно критично: решение должно опираться на корректный массив операций, а не на случайно задублированные данные.',
        },
        { type: 'h2', text: 'Шаг 8. Посмотрите обороты и структуру операций' },
        {
            type: 'paragraph',
            text: 'Следующий шаг - анализ оборотов. ФинРадар показывает движение денег по типам операций, периодам и направлениям. Типы операций ФинРадар размечает автоматически на основе содержимого платежа и данных о контрагенте. Некоторые типы при проверке работают как красная тряпка. Цессии, аномально высокие выдачи под отчет, частые снятия наличных, расчеты банковскими бизнес-картами в дорогих магазинах и ресторанах - очевидные и тем не менее частые способы выводить деньги из бизнеса.',
        },
        {
            type: 'list',
            items: [
                'сколько было поступлений;',
                'сколько было платежей;',
                'какой получился нетто-оборот;',
                'какие типы операций формируют основной поток;',
                'есть ли подотчетные выдачи, цессии, займы, расчеты бизнес-картами и насколько они аномальны;',
                'как менялась активность по месяцам, кварталам или годам;',
                'в любые данные можно провалиться - посмотреть какие конкретно платежи формируют ту или иную сумму.',
            ],
        },
        {
            type: 'paragraph',
            text: 'Это помогает перейти от сырой выписки к понятной структуре финансового движения.',
        },
        {
            type: 'paragraph',
            text: 'Например, для арбитражного управляющего это способ быстро увидеть периоды высокой активности, нетипичные всплески или категории операций, которые требуют отдельной проверки. Для кредитного брокера или МФО - способ быстро оценить характер денежного потока клиента.',
        },
        { type: 'image', image: BLOG_IMAGES.firstCheckOperationTypes },
        { type: 'h2', text: 'Шаг 9. Изучите контрагентов и концентрацию оборотов' },
        {
            type: 'paragraph',
            text: 'Очень полезный раздел первой проверки - обороты по контрагентам. С помощью ФинРадара можно быстро определить:',
        },
        {
            type: 'list',
            items: [
                'основных контрагентов;',
                'суммы поступлений и платежей;',
                'долю контрагента в общем потоке;',
                'количество операций;',
                'структуру концентрации и зависимости от контрагентов;',
                'новых и потерянных контрагентов;',
                'детализацию по отдельному контрагенту.',
            ],
        },
        {
            type: 'paragraph',
            text: 'Это помогает быстро понять, на ком держится движение денег.',
        },
        {
            type: 'paragraph',
            text: 'Если значительная часть поступлений или списаний сосредоточена вокруг 1-3 контрагентов, это важный сигнал. Для арбитражного управляющего такие контрагенты могут стать первыми кандидатами для более глубокой проверки. Для кредитного анализа это может говорить о зависимости бизнеса от ограниченного круга клиентов или поставщиков.',
        },
        {
            type: 'paragraph',
            text: 'В расчеты с любым контрагентом можно развернуть до конкретных операций, посмотреть, что именно указано в назначениях платежей, носят ли платежи регулярный или хаотичный характер, какие счета есть у контрагента. ФинРадар позволяет одной кнопкой выгрузить операции с указанием реквизитов и выписок-источников в Excel-файл, чтобы готовить юридические документы.',
        },
        { type: 'image', image: BLOG_IMAGES.firstCheckCounterparties },
        { type: 'h2', text: 'Шаг 10. Перейдите к реестру платежей' },
        {
            type: 'paragraph',
            text: 'В ФинРадаре можно работать как со стандартными отчетами: по типам операций, по контрагентам, по рискам, - так и с реестром платежей. Реестр платежей - это рабочая таблица со всеми операциями по проекту.',
        },
        {
            type: 'list',
            items: [
                'дату операции;',
                'сумму;',
                'контрагента;',
                'назначение платежа;',
                'тип транзакции;',
                'тип контрагента;',
                'расчетный счет контрагента, если он определен;',
                'операции из конкретных выписок или всего проекта.',
            ],
        },
        {
            type: 'paragraph',
            text: 'Реестр полезен не только для просмотра, но и для уточнения данных. В нем можно посмотреть дополнительные реквизиты контрагента, уточнить тип операции и даже исправить сведения о контрагентах по операциям. В реестре платежей, как и во всех отчетах ФинРадара можно фильтровать платежи по периоду, контрагенту, выписке, сумме, направлению операции, типу транзакции или назначению платежа.',
        },
        { type: 'image', image: BLOG_IMAGES.paymentsRegisterFilters },
        { type: 'h2', text: 'Шаг 11. Откройте отчет по конкретному контрагенту и выгрузите его в Word' },
        {
            type: 'paragraph',
            text: 'Если отдельный контрагент выглядит значимым или рискованным, можно открыть отчет по нему. В отчете расчеты с контрагентом показаны с разных сторон:',
        },
        {
            type: 'list',
            items: [
                'расчеты по периодам;',
                'поступления от контрагента;',
                'платежи контрагенту;',
                'типы транзакций;',
                'долю в общем потоке;',
                'динамику операций;',
                'связанные варианты наименований из выписок;',
                'данные из ЕГРЮЛ.',
            ],
        },
        {
            type: 'paragraph',
            text: 'Такой отчет помогает быстро перейти от общей картины к конкретной связи: кто этот контрагент, сколько денег прошло через него, в какие периоды и по каким типам операций.',
        },
        {
            type: 'paragraph',
            text: 'Отчет по контрагенту можно выгрузить в Word одной кнопкой. При необходимости можно настроить, какие данные включать в отчет и как их сгруппировать для более удобного представления выявленных операций.',
        },
        { type: 'image', image: BLOG_IMAGES.counterpartyReportWord },
        { type: 'h2', text: 'Что считается первым результатом проверки' },
        {
            type: 'paragraph',
            text: 'Первая проверка считается выполненной, когда проект создан, выписки загружены и обработаны, операции сохранены в общий массив, контроль качества не показывает критичных проблем или пользователь понимает, какие файлы требуют внимания. Уже сразу после автоматической обработки выписок в ФинРадаре открывается множество возможностей:',
        },
        {
            type: 'list',
            items: [
                'доступны обороты по типам операций;',
                'доступны контрагенты и структура оборотов;',
                'можно проваливаться в конкретные операции, которые формируют интересующие расчеты - например, что за займы, цессии или платежи на ООО Одуванчик с массовым директором по данным ЕГРЮЛ;',
                'можно работать с реестром платежей;',
                'можно фильтровать операции;',
                'можно переходить к рискам, аномалиям и отчетам по контрагентам.',
            ],
        },
        {
            type: 'paragraph',
            text: 'Первый результат - это не обязательно финальный аналитический отчет. Это рабочая картина, которая позволяет понять, что есть в выписках, какие данные требуют корректировки, где сосредоточены основные обороты, какие контрагенты важны и какие операции и периоды стоит смотреть глубже.',
        },
        {
            type: 'paragraph',
            text: 'Дальнейшая работа может включать получение дополнительных сведений, например, книг покупок и продаж - которые можно добавить в проект в ФинРадаре; проведение сверок с контрагентами; претензионную и исковую работу.',
        },
        { type: 'h2', text: 'Что делать, если файл обработался не сразу' },
        {
            type: 'paragraph',
            text: 'Если файл не обработался мгновенно, это не всегда ошибка. Скорость зависит от формата и сложности выписки. Excel и TXT / 1C Client-Bank обычно обрабатываются быстрее. PDF может потребовать больше времени, особенно если структура нестандартная. Сканированные документы требуют распознавания и относятся к более сложным сценариям.',
        },
        {
            type: 'paragraph',
            text: 'Если файл крупный, нестандартный или требует дополнительной обработки, лучше дождаться статуса в проекте или обратиться в поддержку.',
        },
        { type: 'h2', text: 'Что делать, если обнаружены наложения периодов' },
        {
            type: 'paragraph',
            text: 'Если ФинРадар показывает наложение периодов, нужно проверить, какие выписки пересекаются.',
        },
        {
            type: 'list',
            items: [
                'один и тот же период загружен дважды;',
                'банк сформировал выписку с пересекающимися датами;',
                'пользователь загрузил годовую выписку и отдельно файл за часть того же года;',
                'по счету есть несколько файлов с частичным дублированием.',
            ],
        },
        {
            type: 'paragraph',
            text: 'В этом случае можно открыть отдельную выписку, посмотреть операции, которые она добавляет в общий массив, и удалить лишние операции за период наложения. Главная задача - сохранить корректную базу для дальнейшего анализа.',
        },
        { type: 'h2', text: 'Кому полезна первая проверка в ФинРадаре' },
        {
            type: 'paragraph',
            text: 'ФинРадар можно использовать в разных сценариях.',
        },
        {
            type: 'list',
            items: [
                'Арбитражным управляющим - чтобы быстро собрать массив выписок должника, проверить качество данных, выделить ключевых контрагентов, подозрительные операции и периоды для дальнейшего анализа.',
                'Кредитным брокерам - чтобы заранее оценить клиента, увидеть слабые места в выписке и понять, стоит ли подавать кейс кредитору.',
                'МФО и кредитным аналитикам - чтобы провести первичный анализ заемщика по движению денег, структуре поступлений, концентрации контрагентов и характеру операций.',
                'Финансовым аналитикам и консультантам - чтобы быстрее перейти от банковских файлов к понятной структуре операций и отчетам.',
            ],
        },
        {
            type: 'cta',
            title: 'Попробуйте ФинРадар бесплатно 7 дней',
            text: 'Начать можно с одной выписки. Создайте проект, загрузите файл и посмотрите, какие данные ФинРадар покажет после первой обработки: обороты, операции, контрагентов, фильтры, риски и качество загруженных выписок.',
        },
        {
            type: 'faq',
            items: [
                {
                    question: 'Можно ли начать анализ с одной выписки?',
                    answer: 'Да. Для первой проверки достаточно загрузить одну банковскую выписку. Позже можно добавить новые файлы в тот же проект.',
                },
                {
                    question: 'Какие форматы выписок поддерживает ФинРадар?',
                    answer: 'Лучше всего подходят XLS / XLSX и TXT / 1C Client-Bank. Также ФинРадар работает с текстовыми PDF и другими форматами банковских выписок. Сканированные документы возможны, но требуют более сложной обработки.',
                },
                {
                    question: 'Нужно ли вручную объединять выписки перед загрузкой?',
                    answer: 'Нет. Можно загрузить несколько файлов в один проект. ФинРадар помогает собрать общий массив операций и проверить качество данных по счетам и периодам.',
                },
                {
                    question: 'Что делать, если периоды выписок пересекаются?',
                    answer: 'Нужно открыть проблемную выписку и проверить, какие операции она добавляет в проект. При необходимости лишние операции за пересекающийся период можно удалить.',
                },
                {
                    question: 'Что пользователь увидит после первой проверки?',
                    answer: 'После обработки доступны операции, обороты, контрагенты, фильтры, качество загруженных выписок, а также разделы для анализа рисков и детализации по контрагентам.',
                },
                {
                    question: 'Есть ли бесплатный период?',
                    answer: 'Да. ФинРадар можно попробовать бесплатно в течение 7 дней.',
                },
            ],
        },
    ],
};

export default post;
